// This is the view for when a user first logs in and we need to get some user details,
// In this case we show ths user edit screen but with some specific messaging around it being the first login etc.
import { ViewUserData } from '../views/userData';

export default function UserData() {
    return <ViewUserData isFirstRun={true} />
}